import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { AuthProvider } from '../contexts/auth';
import Routes from '../routes'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const theme = createMuiTheme({
  //@ts-ignore
  typography: {
    fontFamily: '"Exo 2", Arial, Helvetica, sans-serif',
  },
  palette: {
    primary: {
      main: '#64C832',
    },
    secondary: {
      main: '#1e9b32',
    },
    text: {
      primary: '#3e3e3e',
      secondary: '#1e9b32',
    }

  },
});

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <Routes />
        </AuthProvider>
      </ThemeProvider>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnHover={false}
        pauseOnFocusLoss={false}
        draggable={false}
      />
    </>

  );
}

export default App